import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/vercel/path0/components/marketing/contact.tsx");
